import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLogSummaryPage } from './daily-log-summary';
import { DailyLogSummaryComponent } from '../daily-log-summary-component/daily-log-summary-component.component';
import { PipesModule } from '../../../pipes/pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { DailyLogPageModule } from '../daily-log/daily-log.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    DailyLogSummaryPage,
    DailyLogSummaryComponent,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyLogSummaryPage),
    PipesModule,
    SharedModule,
    DailyLogPageModule
  ],
})
export class DailyLogSummaryPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log-summary/daily-log-summary.module.ts